export default __webpack_public_path__ + "i18n/translations/translation-kn.bec6e0d2.json";